import { Grid, Typography } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import Calendar from "~/components/common/calendar/Calendar";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import { ModalBottom } from "~/components/common/modalBottom/modalBottom";
import MuiThemeSelectScheduleTime from "./MuiStylesSelectScheduleTime";
import React from "react";
import ErrorDialog from "~/components/common/dialog";
import businessService from "~/services/businessService";
import { useContext } from "react";
import { DialogBuilder } from "~/utils/DialogProvider";
import couponServices from "~/services/couponServices";
import SEO from "~/components/seo";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { handleBreadcrumb, handleError } from "~/utils/handleError";
import _ from "lodash";
import { useResponsiveText } from "~/hooks/useResponsiveText";
import ScheduleHeader from "~/components/common/scheduleHeader/ScheduleHeader";

const SelectScheduleDate = (props) => {
	const { business } = useSelector((store) => store.business);
	const selectedServices = props?.location?.state?.services;
	const coupon = props?.location?.state?.coupon;
	const isPackage = props?.location?.state?.isPackage;
	const dialog = useContext(DialogBuilder);
	const { id } = useParams();
	const [openError, setOpenError] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);
	const [loading, setLoading] = useState(true);
	const [availableDatesCalendar, setAvailableDatesCalendar] = useState(null);

	const textSize = useResponsiveText();

	const { t } = useTranslation();
	const { user } = useSelector((store) => store.auth);
	const meStore = useSelector((store) => store.me);
	const classes = MuiThemeSelectScheduleTime();
	const startedLoggedOut = useRef(!(user && !user?.isAnonymous)).current;

	const [date, setDate] = useState(null);
	const [selectedDate, setSelectedDate] = useState(null);

	const currentUser = meStore?.me || user || {};
	const isOwnerUser =
		!_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;

	const showError = (message) => {
		setErrorMessage(message);
		setOpenError(true);
	};

	const getAvailableDates = () => {
		let serviceIds = [];
		if (selectedServices) {
			selectedServices.forEach((service) => {
				serviceIds.push(service.featureItems);
			});
			if (coupon) {
				couponServices
					.getAvailableDatesCoupon(business.id, serviceIds, coupon.coupon.coupon_id)
					.then((res) => {
						setLoading(false);
						if (res.data.length === 0) {
							mixpanelTrackEvent("Sem_datas_ou_horarios_disponiveis", {}, currentUser, business);
							dialog
								.withTitle(t("No dates or times available"))
								.withMessage(t("Please contact the establishment"))
								.withAction(() => props.history.goBack())
								.show();
							return;
						}
						setAvailableDatesCalendar(res.data);
					})
					.catch((err) => {
						handleError(err, 'SelectScheduleDate/getAvailableDatesCoupon');
						setLoading(false);
						dialog
							.withTitle(t("Error loading available dates"))
							.withMessage(err?.response?.data?.message)
							.withAction(() => props.history.goBack())
							.show();
					});
			} else {
				businessService
					.getAvailableDates(business.id, serviceIds)
					.then((res) => {
						setLoading(false);
						if (res.data.length === 0) {
							mixpanelTrackEvent("Sem_datas_ou_horarios_disponiveis", {}, currentUser, business);
							dialog
								.withTitle(t("No dates or times available"))
								.withMessage(t("Please contact the establishment"))
								.withAction(() => props.history.goBack())
								.show();
							return;
						}
						setAvailableDatesCalendar(res.data);
					})
					.catch((err) => {
						handleError(err, 'SelectScheduleDate/getAvailableDates');
						setLoading(false);
						dialog
							.withTitle(t("Error loading available dates"))
							.withMessage(err?.response?.data?.message)
							.withAction(() => props.history.goBack())
							.show();
					});
			}
		}
	};

	useEffect(() => {
		if (startedLoggedOut) {
			sessionStorage.setItem('@prit-web/schedulingStartedLoggedOut', 'true');
		} else {
			sessionStorage.removeItem('@prit-web/schedulingStartedLoggedOut');
		}
		handleBreadcrumb('scheduling.date', 'Abriu seleção de data', {
			businessId: id,
			serviceCount: selectedServices?.length,
		});
		if (selectedServices?.length > 0) {
			getAvailableDates();
		} else {
			props.history.push(`/business/${id}`);
		}
	}, []);

	const goToNextPage = (date) => {
		handleBreadcrumb('scheduling.date', 'Data selecionada, avançando para horário', { date });
		if (isOwnerUser) {
			const serviceNamesSelected = selectedServices
				.map((s) => s.serviceName)
				.sort((a, b) => a.localeCompare(b))
				.join(", ");
			const eventProps = {
				Servicos_Selecionados: serviceNamesSelected,
				Data_Selecionada: new Date(date).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" }),
			};
			mixpanelTrackEvent("Avancou_Selecionar_Data", eventProps, currentUser, business);
		}
		props.history.push(`/selecionar-horarios/${id}`, {
			date: date,
			services: selectedServices,
			bookingId: props?.location?.state?.bookingId,
			reservationUpdate: props?.location?.state?.reservationUpdate,
			coupon: coupon,
			reschedule: props?.location?.state?.reschedule,
			isPackage: isPackage,
			availableDatesCalendar: availableDatesCalendar,
			packageSessionInfo: props?.location?.state?.packageSessionInfo,
		});
	};

	const handleOk = () => {
		setOpenError(false);
		props.history.goBack();
	};

	const handleDate = (newDate) => {
		setTimeout(() => {
			goToNextPage(newDate);
		}, 700);		
	};

	return (
		<>
			<TitleContainer
				handleClick={() => (!date ? props.history.goBack() : setDate(null))}
				loading={loading}
				imageVisible={true}
				showGradient={false}
				childrenStyle={{ padding: 0 }}
				backgroundNew={true}
				rightElement={
					<div style={{ backgroundColor: 'rgba(0,0,0,0.8)', borderRadius: 50, padding: '4px 10px' }}>
						<Typography style={{ fontSize: 16, color: "#fff", fontWeight: "300" }}>{t('{{actualStep}} of {{finishStep}}', {
							actualStep: 2,
							finishStep: startedLoggedOut ? 5 : 4
						})}</Typography>
					</div>
				}
				>
				<SEO business={business} page="Agenda" />
				<Grid container direction="column" style={{ Maxheight: "100vh", minHeight: "100vh", background: 'transparent' }}>
					<div
						style={{
							marginTop: 20,
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							marginBottom: 15
						}}>
						<ScheduleHeader 
							title={t("Choose the date")} 
							subtitle={t('You are scheduling {{selectedServices}} {{service}} at {{businessName}}', {
								selectedServices: selectedServices?.length,
								businessName: business?.name,
								service: selectedServices?.length > 1 ? t("services") : t("service")
							})} 
							view={"selectDate"} 
						/>
						<div className={classes.containerChipServices}>
							{selectedServices &&
								selectedServices.map((service) => (
								<div
									key={service.id} 
									style={{
										backgroundColor: "#fff",
										padding: 5,
										borderRadius: 18,
										paddingLeft: 10,
										paddingRight: 10,
										whiteSpace: 'nowrap', 
										overflow: 'hidden',   
										textOverflow: 'ellipsis', 
										minWidth: 0, 
										maxWidth: 'auto', 
										flex: '0 0 auto',
										marginRight: 5,
									}}>
									<Typography style={{ fontSize: 15, color: "#222" }}>
									{service?.serviceName}
									</Typography>
								</div>
								))}
						</div>
					</div>
					<ModalBottom
						animationType="slideRight"
						style={{
							maxWidth: "480px",
							margin: "0 auto",
							width: "100%",
							flex: 1,
							position: "relative",
						}}>
						<Calendar
							setDate={(date) => {
								setSelectedDate(date);
								setTimeout(() => {
									handleDate(date);
								}, 100);
							}}
							date={selectedDate}
							availableDates={availableDatesCalendar}></Calendar>
					</ModalBottom>
					<ErrorDialog onOpen={openError} message={errorMessage} onOk={handleOk} title={t("Attention")} />

				</Grid>	
			</TitleContainer>
		</>
	);
};
export default withRouter(SelectScheduleDate);
